import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../queryKeys';
import { serviceProviders } from '../ServiceProviders';

export const useServiceProviders = () =>
  useQuery({
    queryKey: [QUERY_KEYS.serviceProviders],
    queryFn: async () => (await serviceProviders.getServiceProviders()).data,
  });
